import { Link } from "react-router-dom";
import { MapPin, Clock } from "lucide-react";

// IMAGES
import galle from "../accests/galle/galle.jpeg";
import kandy from "../accests/kan/kan (3).jpeg";
import udawalawe from "../accests/udawalawa/udawalawa (2).jpeg";
import yala from "../accests/yala/leopardImg.jfif";
import sigiriya from "../accests/sigiri/sigiri (11).jpeg";
import whale from "../accests/mirissa/tha.jpeg";
import pinnawala from "../accests/pinna/pinna (5).jpeg";
import kithulgala from "../accests/kithul/kithul.jpeg";
import sinharaja from "../accests/sinharaja/birds.jpeg";
import bentota from "../accests/bentota/ben (2).jpeg";

export default function DayTours() {

    const tours = [
        {
            title: "Galle Day Tour",
            location: "Galle",
            image: galle,
            link: "/tours/day-tours/galle-day-tour"
        },
        {
            title: "Kandy Day Tour",
            location: "Kandy",
            image: kandy,
            link: "/tours/day-tours/kandy-day-tour"
        },
        {
            title: "Udawalawe National Park",
            location: "Udawalawe",
            image: udawalawe,
            link: "/tours/day-tours/udawalawe-day-tour"
        },
        {
            title: "Yala National Park",
            location: "Yala",
            image: yala,
            link: "/tours/day-tours/yala-day-tour"
        },
        {
            title: "Sigiriya & Dambulla",
            location: "Cultural Triangle",
            image: sigiriya,
            link: "/tours/day-tours/sigiriya-dambulla-day-tour"
        },
        {
            title: "Whale Watching Mirissa",
            location: "Mirissa",
            image: whale,
            link: "/tours/day-tours/whale-watching-mirissa"
        },
        {
            title: "Pinnawala Elephant Orphanage",
            location: "Pinnawala",
            image: pinnawala,
            link: "/tours/day-tours/pinnawala-elephant"
        },
        {
            title: "Kithulgala Water Rafting",
            location: "Kithulgala",
            image: kithulgala,
            link: "/tours/day-tours/kithulgala-rafting"
        },
        {
            title: "Sinharaja Rainforest",
            location: "Sinharaja",
            image: sinharaja,
            link: "/tours/day-tours/sinharaja-day-tour"
        },
        {
            title: "Bentota Deep Sea Fishing",
            location: "Bentota",
            image: bentota,
            link: "/tours/day-tours/bentota-fishing"
        }
    ];

    return (
        <div data-aos="fade-up"
             data-aos-duration="3000" className="pt-28 pb-20 bg-gray-50">

            {/* HEADER */}
            <div className="text-center mb-16 px-6">
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                    Welcome to Our <span className="text-red-600">Day Tours</span>
                </h1>
                <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                    Explore Sri Lanka’s best one-day adventures — culture, wildlife, beaches and adrenaline experiences.
                </p>
            </div>

            {/* CARDS */}
            <div data-aos="fade-up"
                 data-aos-duration="3000" className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-10">
                {tours.map((tour, index) => (
                    <Link
                        to={tour.link}
                        key={index}
                        className="group relative rounded-3xl overflow-hidden shadow-xl bg-black"
                    >
                        {/* IMAGE */}
                        <img data-aos="fade-up"
                             data-aos-duration="3000"
                            src={tour.image}
                            alt={tour.title}
                            className="w-full h-[360px] object-cover group-hover:scale-110 transition-transform duration-700"
                        />

                        {/* OVERLAY */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

                        {/* DAY BADGE */}
                        <div className="absolute top-4 left-4 flex items-center gap-2 bg-white text-black px-4 py-1 rounded-full text-sm font-semibold shadow-lg">
                            <Clock size={16} />
                            01 Day
                        </div>

                        {/* CONTENT */}
                        <div className="absolute bottom-6 left-6 right-6 text-white">
                            <h3 className="text-2xl font-bold mb-2">
                                {tour.title}
                            </h3>

                            <div className="flex items-center gap-2 text-sm text-gray-200">
                                <MapPin size={16} className="text-red-500" />
                                {tour.location}
                            </div>
                        </div>
                    </Link>
                ))}
            </div>

        </div>
    );
}
